<div class="plan-div">
    <div class="grid-row">
        <router-outlet></router-outlet>
    </div>
</div>